import { useTranslation } from 'react-i18next';
import { useBasePath } from '~/common/hooks/useBasePath';
import { getLanguageValue, webshopConfig } from '~/config/webshopConfig';
import { useMemo } from 'react';
import { PgArea, TgArea } from '~/common/types/area';
import { Link } from 'react-router';
import { TrackNavigationClick } from '~/tracking/TrackNavigationClick';

export function OwnBrandsNavigation({ className }: Readonly<{ className?: string }>) {
  const { t } = useTranslation();
  const { isAgh } = useBasePath();
  const { i18n } = useTranslation();

  const links = useMemo(() => {
    return webshopConfig.ownBrands.filter(x => !x.area || x.area === (isAgh ? PgArea : TgArea));
  }, [isAgh]);

  return (
    <div className={className} data-testid={'latest-navigation'}>
      <h2 className="block mb-4 text-xl font-bold">{t('Eigenmarken')}</h2>
      <nav>
        <ul className={'space-y-2'}>
          {links.map(({ titleKey, urlDe, urlFr, urlIt }) => {
            const link = getLanguageValue(i18n.language, { de: urlDe, fr: urlFr, it: urlIt });

            return (
              <li key={titleKey}>
                <TrackNavigationClick label={titleKey}>
                  <Link to={link} className="hover:text-primary" data-testid={`own-brands-navigation-${titleKey}`}>
                    <h3 className={'text-base font-normal'}>{titleKey}</h3>
                  </Link>
                </TrackNavigationClick>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
